import { useState, useCallback } from 'react';

/**
 * Hook para gestionar notificaciones del sistema
 * @returns {Object} Objeto con notificaciones y funciones para manejarlas
 */
const useNotification = () => {
  const [notifications, setNotifications] = useState([]);

  /**
   * Mostrar una nueva notificación
   * @param {string} message - Mensaje de la notificación
   * @param {string} type - Tipo de notificación (success, error, warning, info)
   * @param {number} duration - Duración en milisegundos (0 para no auto-cerrar)
   */
  const showNotification = useCallback((message, type = 'info', duration = 5000) => {
    const id = Date.now().toString();
    const notification = {
      id,
      message,
      type,
      timestamp: new Date()
    };

    setNotifications(prev => [...prev, notification]);

    // Auto-cerrar si se especifica duración
    if (duration > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, duration);
    }
  }, []);

  /**
   * Remover una notificación específica
   * @param {string} id - ID de la notificación a remover
   */
  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  }, []);

  /**
   * Limpiar todas las notificaciones
   */
  const clearNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  return {
    notifications,
    showNotification,
    removeNotification,
    clearNotifications
  };
};

export { useNotification }; 